module.exports = __webpack_public_path__ + "img/names_icon.389f2ff8.jpg";